import { useEffect, useState } from 'react';

export default function useSyncState(v, deps = []) {
  const [value, setValue] = useState(v);
  useEffect(() => setValue(v), [v, ...deps]);
  return [value, setValue];
}
